/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_FoodInputs */

const en_gc_home_food = /** @type {(inputs: Gc_Home_FoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groceries`)
};

const zh_gc_home_food = /** @type {(inputs: Gc_Home_FoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`食品`)
};

/**
* | output |
* | --- |
* | "Groceries" |
*
* @param {Gc_Home_FoodInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_food = /** @type {((inputs?: Gc_Home_FoodInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_FoodInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_food(inputs)
	return zh_gc_home_food(inputs)
});
export { gc_home_food as "gc.home.food" }